import MicroModal from 'micromodal';

const qs = (selector, root = document) => root ? root.querySelector(selector) : null;
const qsa = (selector, root = document) => root ? Array.from(root.querySelectorAll(selector)) : [];

const findInForm = (form, selector) => qs(selector, form) || qs(selector);

const setButtonText = (button, text) => {
  if (button) {
    button.innerHTML = text;
  }
};

const showMessage = (element, msg) => {
  if (element) {
    element.style.display = 'block';
    element.innerHTML = msg || '';
  }
};

const resetButton = (button, text) => {
  if (button) {
    button.disabled = false;
    button.innerHTML = text;
  }
};

const postFormDataAsJson = async ({ url, formData }) => {
  const plainFormData = Object.fromEntries(formData.entries());
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(plainFormData),
  };
  const response = await fetch(url, fetchOptions);
  if (!response.ok) {
    const errorMessage = await response.text();
    throw new Error(errorMessage);
  }
  return response.json();
};

const redirectToGame = (form) => {
  if (window.ftb_timeout > 0) {
    const loginButton = findInForm(form, '[data-landing-submit], #login_btn');

    if (window.login_success_class && loginButton) {
      loginButton.classList.add(window.login_success_class);
    }

    window.ftb();
    setTimeout(() => {
      window.location.href = window.URL_route;
    }, window.ftb_timeout);
  } else {
    window.location.href = window.URL_route;
  }
};

const handleFormSubmit = async (event, url, successCallback, errorCallback) => {
  event.preventDefault();

  const form = event.currentTarget;
  const formData = new FormData(form);

  try {
    const responseData = await postFormDataAsJson({ url, formData });
    const { status, bc_id, msg, tkn, nick } = responseData;

    if (status !== 1) {
      errorCallback(msg);
      return;
    }

    const bodyContent = window.hub_support
      ? { bc_id, token: tkn, uid: bc_id, nick }
      : {
          login_name: formData.get('login_name'),
          password: formData.get('password'),
          token: tkn,
        };

    const fetchOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(bodyContent),
    };

    const response = await fetch(window.URL_login, fetchOptions);
    const data = await response.json();

    if (data.status === 1) {
      successCallback(data);
      redirectToGame(form);
    } else {
      errorCallback(data.msg || msg);
    }
  } catch (error) {
    console.log(error.message);
    errorCallback('');
  }
};

const handleLoginFormSubmit = (event) => {
  const form = event.currentTarget;
  const loginButton = findInForm(form, '[data-landing-submit], #login_btn');
  const loginMsg = findInForm(form, '[data-landing-message], #login_msg');
  const url = window.hub_support ? `${window.HUB_URL}users/authgam3` : window.URL_login;

  setButtonText(loginButton, 'Logging in...');

  const successCallback = () => {
    setButtonText(loginButton, window.login_text);
  };

  const errorCallback = (msg) => {
    showMessage(loginMsg, msg);
    resetButton(loginButton, 'Log In');
  };

  handleFormSubmit(event, url, successCallback, errorCallback);
};

const handleRegisterFormSubmit = (event) => {
  const form = event.currentTarget;
  const registerButton = findInForm(form, '[data-landing-submit], #register_btn');
  const registerMsg = findInForm(form, '[data-landing-message], #register_msg');
  const url = window.hub_support ? `${window.TD_URL}users/add` : window.URL_install;

  setButtonText(registerButton, window.registering_text);

  const successCallback = () => {
    setButtonText(registerButton, window.installing_text);
  };

  const errorCallback = (msg) => {
    showMessage(registerMsg, msg);
    resetButton(registerButton, window.register_button_label);
  };

  handleFormSubmit(event, url, successCallback, errorCallback);
};

const goTopBtn = qs('#back_to_top');

const trackScroll = () => {
  if (!goTopBtn) {
    return;
  }

  const scrolled = window.pageYOffset;
  const coords = document.documentElement.clientHeight / 2;

  if (scrolled > coords) {
    goTopBtn.classList.add('show');
  } else {
    goTopBtn.classList.remove('show');
  }
};

const backToTop = () => {
  if (window.scrollY > 0) {
    window.scrollBy(0, -80);
    requestAnimationFrame(backToTop);
  }
};

if (goTopBtn) {
  window.addEventListener('scroll', trackScroll);
  goTopBtn.addEventListener('click', backToTop);
}

const closeMobileNav = () => {
  const mobileToggle = qs('#mobile_nav input');

  if (mobileToggle) {
    mobileToggle.checked = false;
  }
};

qsa('#menu a').forEach((anchor) => {
  anchor.addEventListener('click', closeMobileNav);
});

const smoothScrolling = (event) => {
  const href = event.currentTarget.getAttribute('href');

  if (!href || href === '#' || !href.startsWith('#')) {
    return;
  }

  let target = null;
  try {
    target = qs(href);
  } catch (error) {
    return;
  }

  if (!target) {
    return;
  }

  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth' });
  closeMobileNav();
};

qsa('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener('click', smoothScrolling);
});

// fade screen to black after login/signup
window.ftb = function() {
  const ftb = qs('.ftb');

  if (!ftb) {
    return;
  }

  ftb.style.display = 'block';
  setTimeout(() => ftb.classList.add('active'), 50);
};

const accordion = (event) => {
  const item = event.currentTarget;
  const panel = item.nextElementSibling;
  const setClasses = !item.classList.contains('active');

  qsa('.accordion.active').forEach((activeItem) => activeItem.classList.remove('active'));
  qsa('.answer-panel.show').forEach((openPanel) => openPanel.classList.remove('show'));

  if (setClasses && panel && panel.classList.contains('answer-panel')) {
    item.classList.add('active');
    panel.classList.add('show');
  }
};

qsa('.accordion').forEach((panel) => {
  panel.addEventListener('click', accordion);
});

const ensureScreenshotModal = () => {
	let modal = qs('#screenshot-modal');

	if (modal) {
    return modal;
  }

  modal = document.createElement('div');
  modal.className = 'modal micromodal-slide screenshot_modal';
  modal.id = 'screenshot-modal';
  modal.setAttribute('aria-hidden', 'true');
  modal.innerHTML = `
    <div class="modal__overlay" tabindex="-1" data-micromodal-close>
      <div class="modal__container" role="dialog" aria-modal="true" aria-label="Screenshot preview">
        <button class="modal__close" aria-label="Close screenshot" data-micromodal-close></button>
        <div class="screenshot_modal__stage">
          <img class="screenshot_modal__image" alt="">
          <div class="screenshot_modal__thumbs" aria-label="Screenshot thumbnails"></div>
        </div>
      </div>
    </div>
  `;
	document.body.appendChild(modal);

	return modal;
};

let activeScreenshotImages = [];
let activeScreenshotIndex = 0;
let screenshotModalKeysBound = false;

const screenshotImageData = (image) => ({
	src: image.currentSrc || image.src,
	alt: image.alt || 'Screenshot preview',
});

const normalizeScreenshotIndex = (index) => {
	if (!activeScreenshotImages.length) {
		return 0;
	}

	return (index + activeScreenshotImages.length) % activeScreenshotImages.length;
};

const updateScreenshotModal = () => {
	const modal = ensureScreenshotModal();
	const modalImage = qs('.screenshot_modal__image', modal);
	const thumbnails = qs('.screenshot_modal__thumbs', modal);

	if (!modalImage) {
		return;
	}

	const activeImage = activeScreenshotImages[activeScreenshotIndex];

	modalImage.src = activeImage.src;
	modalImage.alt = activeImage.alt;

	if (!thumbnails) {
		return;
	}

	thumbnails.innerHTML = '';
	activeScreenshotImages.forEach((image, index) => {
		const thumbnail = document.createElement('button');
		const thumbnailImage = document.createElement('img');
		const isActive = index === activeScreenshotIndex;
		const isPrevious = activeScreenshotImages.length > 1 && index === normalizeScreenshotIndex(activeScreenshotIndex - 1);
		const isNext = activeScreenshotImages.length > 1 && index === normalizeScreenshotIndex(activeScreenshotIndex + 1);

		thumbnail.className = 'screenshot_modal__thumb';
		if (isPrevious) {
			thumbnail.classList.add('screenshot_modal__thumb--previous');
		}
		if (isNext) {
			thumbnail.classList.add('screenshot_modal__thumb--next');
		}
		thumbnail.type = 'button';
		thumbnail.setAttribute('aria-label', `Show screenshot ${index + 1}`);
		thumbnail.setAttribute('aria-current', isActive ? 'true' : 'false');
		thumbnail.dataset.index = index;
		thumbnailImage.src = image.src;
		thumbnailImage.alt = image.alt;
		thumbnail.appendChild(thumbnailImage);
		thumbnails.appendChild(thumbnail);
	});
};

const showScreenshotIndex = (index) => {
	activeScreenshotIndex = normalizeScreenshotIndex(index);
	updateScreenshotModal();
};

const handleScreenshotModalKeys = (event) => {
	if (!qs('#screenshot-modal.is-open')) {
		return;
	}

	if (event.key === 'ArrowLeft') {
		event.preventDefault();
		showScreenshotIndex(activeScreenshotIndex - 1);
	}

	if (event.key === 'ArrowRight') {
		event.preventDefault();
		showScreenshotIndex(activeScreenshotIndex + 1);
	}
};

const bindScreenshotModal = () => {
	const modal = ensureScreenshotModal();
	const thumbnails = qs('.screenshot_modal__thumbs', modal);

	if (thumbnails && !thumbnails.dataset.bound) {
		thumbnails.dataset.bound = 'true';
		thumbnails.addEventListener('click', (event) => {
			const thumbnail = event.target.closest ? event.target.closest('.screenshot_modal__thumb') : null;

			if (!thumbnail || !thumbnails.contains(thumbnail)) {
				return;
			}

			showScreenshotIndex(parseInt(thumbnail.dataset.index, 10));
		});
	}

	if (!screenshotModalKeysBound) {
		screenshotModalKeysBound = true;
		document.addEventListener('keydown', handleScreenshotModalKeys);
	}
};

const openScreenshotModal = (image, galleryImages = [image]) => {
	const imageList = galleryImages.map(screenshotImageData);
	const imageIndex = galleryImages.indexOf(image);

	activeScreenshotImages = imageList.length ? imageList : [screenshotImageData(image)];
	activeScreenshotIndex = normalizeScreenshotIndex((imageIndex > -1) ? imageIndex : 0);
	bindScreenshotModal();
	updateScreenshotModal();
	MicroModal.show('screenshot-modal', { disableFocus: true });
};

const prepareScreenshotImages = (container) => {
	const images = qsa('.image_item', container);

	images.forEach((image) => {
		image.setAttribute('draggable', 'false');

		if (!image.hasAttribute('tabindex')) {
			image.setAttribute('tabindex', '0');
		}

		if (!image.hasAttribute('role')) {
			image.setAttribute('role', 'button');
		}

		image.addEventListener('keydown', (event) => {
			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault();
				openScreenshotModal(image, images);
			}
		});
	});

	return images;
};

const setupScreenshotCarousels = () => {
	qsa('.screenshot_carousel').forEach((carousel) => {
		let pointerDown = false;
		let hasDragged = false;
    let suppressClick = false;
    let startX = 0;
    let startScrollLeft = 0;

    const startDrag = (clientX) => {
      pointerDown = true;
      hasDragged = false;
      startX = clientX;
      startScrollLeft = carousel.scrollLeft;
      carousel.classList.add('is-dragging');
    };

    const moveDrag = (clientX, event) => {
      if (!pointerDown) {
        return;
      }

      const deltaX = clientX - startX;

      if (Math.abs(deltaX) > 4) {
        hasDragged = true;
        carousel.scrollLeft = startScrollLeft - deltaX;
        event.preventDefault();
      }
    };

		const images = prepareScreenshotImages(carousel);

    carousel.addEventListener('dragstart', (event) => {
      event.preventDefault();
    });

    carousel.addEventListener('pointerdown', (event) => {
      if (event.button !== 0) {
        return;
      }

      startDrag(event.clientX);

      if (carousel.setPointerCapture) {
        carousel.setPointerCapture(event.pointerId);
      }
    });

    carousel.addEventListener('pointermove', (event) => {
      moveDrag(event.clientX, event);
    });

    const endDrag = (event) => {
      if (!pointerDown) {
        return;
      }

      pointerDown = false;
      carousel.classList.remove('is-dragging');

      if (carousel.releasePointerCapture && event.pointerId !== undefined) {
        carousel.releasePointerCapture(event.pointerId);
      }

      if (hasDragged) {
        suppressClick = true;
        setTimeout(() => {
          suppressClick = false;
        }, 120);
      }
    };

    carousel.addEventListener('pointerup', endDrag);
    carousel.addEventListener('pointercancel', endDrag);
    carousel.addEventListener('pointerleave', endDrag);

    carousel.addEventListener('mousedown', (event) => {
      if (event.button !== 0) {
        return;
      }

      startDrag(event.clientX);
      event.preventDefault();
    });

    document.addEventListener('mousemove', (event) => {
      moveDrag(event.clientX, event);
    });

    document.addEventListener('mouseup', endDrag);

    carousel.addEventListener('click', (event) => {
      const image = event.target.closest ? event.target.closest('.image_item') : null;

      if (!image || !carousel.contains(image)) {
        return;
      }

      if (suppressClick) {
        event.preventDefault();
        suppressClick = false;
        return;
      }

			openScreenshotModal(image, images);
		});
	});
};

const setupScreenshotGrids = () => {
	qsa('.screenshot_grid').forEach((grid) => {
		const images = prepareScreenshotImages(grid);

		grid.addEventListener('click', (event) => {
			const image = event.target.closest ? event.target.closest('.image_item') : null;

			if (!image || !grid.contains(image)) {
				return;
			}

			openScreenshotModal(image, images);
		});
	});
};

setupScreenshotCarousels();
setupScreenshotGrids();

if (qs('.modal')) {
  MicroModal.init({
    disableFocus: true,
    onShow: () => {
      const loginInput = qs('#register_container [name="login_name"]:not([type="hidden"])');

      if (loginInput) {
        loginInput.focus();
      }
    },
  });
}

qsa('form[data-landing-action="login"], #login_form').forEach((loginForm) => {
  loginForm.addEventListener('submit', handleLoginFormSubmit);
});

qsa('form[data-landing-action="register"], #register_form').forEach((registerForm) => {
  registerForm.addEventListener('submit', handleRegisterFormSubmit);
});
